import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { BuyConfirmationDialog } from '@sorare/marketplace/src/components/buyActions/BuyConfirmationDialog';
import { BuyTokenConfirmation } from '@sorare/marketplace/src/components/buyActions/BuyTokenConfirmation';

import type { CardConfirmedDialog_anyCardInterface } from './__generated__/index.graphql.ts';

type Props = {
  onClose: () => void;
  card: CardConfirmedDialog_anyCardInterface;
};

export const CardConfirmedDialog = ({ onClose, card }: Props) => {
  return (
    <BuyConfirmationDialog open onClose={onClose}>
      <BuyTokenConfirmation card={card} onClose={onClose} />
    </BuyConfirmationDialog>
  );
};

CardConfirmedDialog.fragments = {
  anyCardInterface: gql`
    fragment CardConfirmedDialog_anyCardInterface on AnyCardInterface {
      slug
      ...BuyTokenConfirmation_anyCard
    }
    ${BuyTokenConfirmation.fragments.anyCard}
  ` as TypedDocumentNode<CardConfirmedDialog_anyCardInterface>,
};
